import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Radio,
  TextField,
  Typography,
  Button,
} from '@material-ui/core';

import Box from 'retired/Box';
import FormFieldLabel from 'retired/FormFieldLabel';
import FormFileUpload from 'retired/FormFileUpload';
import { isURL } from 'utils/validators';

import { FaqLinkData } from './actions';

const isUrlValidator = isURL();

const FaqForm = ({
  faqLink,
  submitForm,
}: {
  faqLink: string;
  submitForm: (data: FaqLinkData) => void;
}): React.ReactElement => {
  const [uploadFaq, setUploadFaq] = useState(false);
  const [newFaqLink, setNewFaqLink] = useState(faqLink);

  const isFaqDocumentStoredOnDeed = /godeed.today|joindeed.org/.test(newFaqLink);

  useEffect(() => {
    setUploadFaq(isFaqDocumentStoredOnDeed);
  }, [newFaqLink]);

  useEffect(() => {
    setNewFaqLink(faqLink);
  }, [faqLink]);

  return (
    <Box style={{ paddingTop: 0, marginBottom: 30 }}>
      <h2>Navigation Links</h2>
      <FormFieldLabel>FAQ</FormFieldLabel>
      <Accordion expanded={!uploadFaq} onChange={() => setUploadFaq(false)}>
        <AccordionSummary>
          <Radio checked={!uploadFaq} onChange={() => setUploadFaq(false)} color="primary" />
          <p>Add a link to your FAQ</p>
        </AccordionSummary>
        <AccordionDetails>
          <TextField
            fullWidth
            label="Paste link to your FAQ document"
            placeholder="FAQ Link"
            value={isFaqDocumentStoredOnDeed ? '' : newFaqLink}
            onChange={(e) => setNewFaqLink(e.target.value)}
            helperText={isUrlValidator(newFaqLink)}
            error={!!isUrlValidator(newFaqLink)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={uploadFaq}
        onChange={() => setUploadFaq(true)}
        style={{ marginBottom: 20 }}
      >
        <AccordionSummary>
          <Radio checked={uploadFaq} onChange={() => setUploadFaq(true)} color="primary" />
          <p>Upload a PDF document of your FAQ</p>
        </AccordionSummary>
        <AccordionDetails style={{ display: 'block', marginTop: -50 }}>
          <FormFileUpload
            acceptedTypes="application/pdf"
            linkPreview={isFaqDocumentStoredOnDeed}
            input={{
              value: !isFaqDocumentStoredOnDeed ? '' : newFaqLink || faqLink,
              onChange: (url: string) => setNewFaqLink(url),
            }}
            contentDisposition="inline"
            meta={{}}
          />
        </AccordionDetails>
      </Accordion>
      <Typography align="right">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={() => submitForm({ faqLink: newFaqLink })}
        >
          Submit
        </Button>
      </Typography>
    </Box>
  );
};

export default FaqForm;
